"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const uuid_1 = require("uuid");
const tape_builder_base_1 = require("../../types/tape-builder-base");
const cloneUtils_1 = require("../cloneUtils");
const node_1 = require("./node");
// The reconciled-bus-tape node is not facility/loan-product scoped — its
// converter + IntermediateRecord type always null creditFacilitySlug and
// loanProductSlug, so the clone must too (keep clone consistent with commit).
const cloneConfig = ({ config, cloneMap, }) => (0, tape_builder_base_1.remapArtifactSlugRefs)(node_1.NodeConfigSchema, config, (slug) => (0, cloneUtils_1.getClonedArtifactSlug)(slug, cloneMap));
const cloneFromTemplateArtifact = ({ artifactToClone, newArtifactDocumentId, cloneMap, }) => {
    const configuration = cloneConfig({
        config: artifactToClone.configuration,
        cloneMap,
    });
    return {
        artifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(artifactToClone.artifactSlug, cloneMap),
        artifactDocumentId: newArtifactDocumentId,
        creditFacilitySlug: null,
        loanProductSlug: null,
        externalFilename: null,
        id: (0, uuid_1.v4)(),
        type: node_1.artifactType,
        configuration,
    };
};
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map